//============================================================================
// Name        : api_logs.ts
// Purpose     : Implement handheld api logs
// Created     : 2020-01-31
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import {InitPage} from "../../index";

class HandheldApiLogs {
    targetUrl: string;

    constructor() {
        const logSelEl = $("#module_name") as any;
        logSelEl.select2();

        const catEl = $("#override_by_category") as any;
        catEl.select2({ width: "100%" });

        const zoneSelEl = $("#override_by_zone") as any;
        zoneSelEl.select2({ width: "100%" });

        const manufacturerSelEl = $("#override_by_manufacturer") as any;
        manufacturerSelEl.select2({ width: "100%" });

        // Bind Reprocess dialog actions
        $(".reprocess-btn").on("click", (e) => {
            const btn = $(e.target);
            this.targetUrl = btn.data("url");

            $("#reprocess-dialog").modal("show");
        });

        $('#module_name').on('select2:select', function (e) {
            $('#search-form').submit();
        });

        $("#continue-btn").on("click", (e) => {
            const overrideQty = $("#override_qty").is(":checked");

            let newTargetUrl = this.targetUrl;
            if (overrideQty) {
                newTargetUrl = newTargetUrl + "&override_qty=true";
            }

            if ($("#override_by_category_enabled").is(":checked")) {
                const selectedCategories = $("#override_by_category option:selected");
                const cats = [];
                if (selectedCategories.length > 0) {
                    Array.from(selectedCategories).map(cat => cats.push( $(cat).val() ));

                    newTargetUrl = newTargetUrl + `&override_by=category&override_by_category=category`;
                    newTargetUrl = newTargetUrl + `&categories=${cats.join(",")}`;
                }
            }
            const selectedZone = $("#override_by_zone option:selected").val();
            if (selectedZone) {
                newTargetUrl = newTargetUrl + `&subzone=${selectedZone}`;
            }
            if ($("#override_by_zone_enabled").is(":checked")) {
                newTargetUrl = newTargetUrl + `&subzone=${selectedZone}&override_by_zone=zone`;
            }

            const selectedManufacturer = $("#override_by_manufacturer option:selected").val();
            if (selectedManufacturer) {
                newTargetUrl = newTargetUrl + `&override_by_mf=manufacturer${selectedManufacturer}`;
            }
            if ($("#override_by_manufacturer_enabled").is(":checked")) {
                newTargetUrl = newTargetUrl + `&override_by_mf=${selectedManufacturer}&override_by_manufacturer=manufacturer`;
            }

            if ($("#override_quantity").is(":checked")) {
              newTargetUrl = newTargetUrl + `&override_quantity=true`;
            }

            const processingVersion = $("#processing_version option:selected").val();
            newTargetUrl = newTargetUrl + `&processing_version=V2`;
            location.href = newTargetUrl;
        });

        $('.comment').on('click', (e) => {
            e.preventDefault();
            $('#comment_message').text(e.currentTarget.dataset.comment);
            $("#comments").modal("show");
        })
    }
}

export function LoadPage() {
    InitPage("api_logs index", () => {
        const c = new HandheldApiLogs();
    });
}
